import { Select } from '@common/ui'
import { com } from '@eidu/web'
import { knownKinds } from '../../domain/kindRegistry'
import EntityTypeKind = com.eidu.entity.type.EntityTypeKind
import entityTypeKindFromString = com.eidu.entity.type.entityTypeKindFromString

export type KindInputProps = {
  kind?: EntityTypeKind
  setKind?: (kind: EntityTypeKind) => void
  editable?: boolean
}

const sortedKnownKinds = [...knownKinds].sort((a, b) => a.toString().localeCompare(b.toString()))

const KindInput = ({ kind, setKind = () => {}, editable = false }: KindInputProps) => (
  <Select
    value={kind?.toString() ?? null}
    onChange={(value) => value && setKind(entityTypeKindFromString(value))}
    disabled={!editable}
    data={sortedKnownKinds.map((value) => value.toString())}
  />
)

export default KindInput
